import Employees from './Employees';
import EditEmployee from './EditEmployee';
import Departments from './Departments';
import EditDepartment from './EditDepartment';
import RoleType from './RoleType';
import EditRoleType from './EditRoleType';
import Users from './Users';
import EditUser from './EditUser';
import CreateUserFromEmployee from './CreateUserFromEmployee';
import DetailUser from './DetailUser';

export {
  Employees,
  EditEmployee,
  Departments,
  EditDepartment,
  RoleType,
  EditRoleType,
  Users,
  EditUser,
  CreateUserFromEmployee,
  DetailUser,
};

export default {
  Employees,
  EditEmployee,
  Departments,
  EditDepartment,
  RoleType,
  EditRoleType,
  Users,
  EditUser,
  DetailUser,
  CreateUserFromEmployee,
};
